<template>
  <div class="container">
    <div class="white-frame">
      <div class="title-text mb-3">
        <b>Dados do Segurado</b>
      </div>
      <div class="row g-3">
        <div
          class="col-md-6"
          :class="{ 'field-required': validation.Nome.$invalid }"
        >
          <label for="nome_segurado" class="form-label">Nome completo</label>
          <InputText
            id="nome_segurado"
            v-model="segurado.Nome"
            class="form-control"
          />
        </div>
        <div
          class="col-md-6"
          :class="{ 'field-required': validation.NrContribuinte.$invalid }"
        >
          <label for="cpf_segurado" class="form-label">CPF/CNPJ</label>
          <mask-input
            id="cpf_segurado"
            type="text"
            v-model="segurado.NrContribuinte"
            class="form-control p-inputtext p-component"
            :mask="MASKS.cpfCnpjMask"
            :unmask="true"
          />
        </div>
        <div
          class="col-md-6"
          :class="{ 'field-required': validation.DataNascimento.$invalid }"
          v-if="!isCnpjValid"
        >
          <label for="dataNascimento_segurado" class="form-label"
            >Data Nascimento</label
          >
          <Calendar
            v-model="segurado.DataNascimento"
            dateFormat="dd/mm/yy"
            selectionMode="single"
            :showOnFocus="false"
            :showIcon="true"
            :manualInput="true"
            :maxDate="maxDate"
            placeholder="dd/mm/aaaa"
            class="form-control p-0"
          />
        </div>
        <div
          class="col-md-6"
          :class="{ 'field-required': validation.nrID.$invalid }"
          v-if="!isCnpjValid"
        >
          <label for="rg_segurado" class="form-label">RG</label>
          <InputText
            id="rg_segurado"
            v-model="segurado.nrID"
            class="form-control"
          />
        </div>

        <div
          class="col-md-6"
          :class="{ 'field-required': validation.Email.$invalid }"
        >
          <label for="email_segurado" class="form-label">Email</label>
          <InputText
            id="email_segurado"
            v-model="segurado.Email"
            class="form-control"
          />
        </div>
        <div
          class="col-md-6"
          :class="{ 'field-required': validation.Telemovel.$invalid }"
        >
          <label for="telemovel_segurado" class="form-label">Celular</label>
          <mask-input
            id="telemovel_segurado"
            type="text"
            :mask="MASKS.telemovel"
            :unmask="true"
            v-model="segurado.Telemovel"
            class="form-control p-inputtext p-component"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { IMaskComponent } from 'vue-imask';
import { MASKS } from '../utils/constants';
import { cnpjValid } from '../utils/customValidations';

export default {
  components: { 'mask-input': IMaskComponent },
  props: {
    segurado: Object,
    validation: Object,
  },
  data() {
    return {
      maxDate: new Date(),
      yearRange: `1900:${new Date().getUTCFullYear()}`,
      MASKS: MASKS,
    };
  },
  computed: {
    isCnpjValid() {
      return cnpjValid(this.segurado.NrContribuinte);
    },
  },
};
</script>
